import { render, staticRenderFns } from "./WUpload.vue?vue&type=template&id=a8169e86&"
import script from "./WUpload.vue?vue&type=script&lang=js&"
export * from "./WUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports